export var IndexRestoreMode;
(function (IndexRestoreMode) {
    IndexRestoreMode["INDEX_RESTORE_MODE_UNSPECIFIED"] = "INDEX_RESTORE_MODE_UNSPECIFIED";
    IndexRestoreMode["INDEX_RESTORE_MODE_KEEP"] = "INDEX_RESTORE_MODE_KEEP";
    IndexRestoreMode["INDEX_RESTORE_MODE_DISCARD"] = "INDEX_RESTORE_MODE_DISCARD";
})(IndexRestoreMode || (IndexRestoreMode = {}));
